const DEVICE = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile'
}

export {
    DEVICE
}
